/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "nexturgencycontact",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_contacts: null,
	_index: 0,
	_ordered: false, // Whether urgency contacts should be called in order each time
	_has_cycled: false,

	next_index: next_index,
	next_contact: next_contact,
});

function init() {
	this._contacts = [];
	this._index = -1;
	this.push(null);
}

function uninit() {
	this._contacts = null;
}

function listeners() {
	return {
		"availableurgencycontacts:updated": handle_contact_update,
		"urgencypreferences:updated": handle_urgency_preferences_update,
	};
}

function triggers() {
	return {
		"next": next_contact,
		"reset": reset_index,
	};
}

function next_contact() {
	var index = this.next_index();
	var contact = this._contacts[index];
	this.push(contact || null);
}

function reset_index() {
	if (this._ordered)
		this._index = -1;

	this.next_contact();
}

function next_index() {
	var index = this._index + 1;
	var contacts = this._contacts;

	if (index >= contacts.length) {
		index = 0;
		// Emit an event saying we've done a full cycle
		if (!this._has_cycled) {
			this.emit("urgencyhistory:trigger:cycle");
			this._has_cycled = true;
		}
	} else {
		this._has_cycled = false;
	}

	this._index = index;

	return index;
}

function handle_contact_update(contacts) {
	this._contacts = contacts;
}

function handle_urgency_preferences_update(preferences) {
	this._ordered = !!preferences.ordered;
}
